<template>
  <div
    v-editable="contact && !contact.isGlobal"
    :class="{
      'pb-7 pt-10': blok.useCardStyle,
      'space-y-6': !blok.useCardStyle,
    }"
  >
    <div class="min-w-max">
      <img
        :src="
          getImgSrc({
            imgUrl: contact.profileImage?.filename,
            width: 300,
            height: 300,
          })
        "
        class="mx-auto rounded-full"
        :class="
          large ? 'h-60 w-60 sm:h-64 sm:w-64' : 'h-40 w-40 xl:h-56 xl:w-56'
        "
        :alt="contact.profileImage?.alt"
        loading="lazy"
      />
    </div>
    <div
      class="space-y-2"
      :class="{
        'mt-6 px-7 md:w-[25rem]': blok.useCardStyle,
        'md:w-80': !blok.useCardStyle,
      }"
    >
      <div
        class="text-center font-medium leading-6"
        :class="blok.useCardStyle ? 'space-y-4 text-base' : 'space-y-4 text-lg'"
      >
        <div class="space-y-1">
          <h3
            v-if="contact.name"
            class="font-bold"
            :class="[
              textColorClass(blok.textVariant, backgrounColor),
              { 'text-lg': blok.useCardStyle },
            ]"
          >
            {{ contact.name }}
          </h3>
          <p
            v-if="contact.jobTitle"
            :class="textColorClass(blok.textVariant, backgrounColor)"
          >
            {{ contact.jobTitle }}
          </p>

          <p
            v-if="contact.extraInfo"
            :class="textColorClass(blok.textVariant, backgrounColor)"
          >
            {{ contact.extraInfo }}
          </p>
        </div>

        <div class="space-y-1">
          <p v-if="contact.phone" :class="linkTextColor">
            <span class="whitespace-nowrap">
              <a
                :href="`tel:${contact.phone}`"
                :aria-label="`Bel ${contact.phone} voor meer informatie`"
              >
                <PhoneIcon class="mr-1 inline h-5 w-5" />
                {{ contact.phone }}
              </a>
            </span>
          </p>
          <p v-if="contact.email" :class="linkTextColor">
            <span>
              <a
                :href="`mailto:${contact.email}`"
                :aria-label="`E-Mail ${contact.email}`"
              >
                <EnvelopeIcon class="mr-1 inline h-5 w-5" />
                {{ contact.email }}
              </a>
            </span>
          </p>
        </div>
      </div>
      <div
        v-if="
          contact.callToActionButtons && contact.callToActionButtons.length > 0
        "
        class="flex flex-col py-2"
        :class="{ 'pt-4': blok.useCardStyle }"
      >
        <component
          :is="btn.component"
          v-for="btn in contact.callToActionButtons"
          :key="btn._uid"
          :item="btn"
          :blok="blok"
          class="mt-4 w-full text-center first:mt-0"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import WhatsappButton from './WhatsappButton.vue'
import LinkedinButton from './LinkedinButton.vue'
import TwitterButton from './TwitterButton.vue'
import FacebookButton from './FacebookButton.vue'
import CallToActionButton from './CallToActionButton.vue'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/20/solid'
import { useColorPalette } from '../composables/colorPalette'
import { getImgSrc } from '../utils/imgUtils'

const props = defineProps({
  blok: {
    type: Object,
    default: () => null,
  },
  contact: {
    type: Object,
    required: true,
  },
  large: {
    type: Boolean,
    default: false,
  },
})

// All of these components can be added dynamically to component
defineOptions({
  components: {
    CallToActionButton,
    WhatsappButton,
    LinkedinButton,
    TwitterButton,
    FacebookButton,
  },
})

const { isBackgroundDark, textColorClass, colorName } = useColorPalette()

const backgrounColor = computed(() => {
  return props.blok.useCardStyle ? 'white' : props.blok.bgVariant
})
const linkTextColor = computed(() => {
  let colorProp = props.blok.linkTextColor
  if (!colorProp) {
    colorProp = isBackgroundDark(backgrounColor.value) ? 'white' : 'default'
  }

  return `richtext-link ${colorName(colorProp)}`
})
</script>
